import React, { useState, useEffect } from 'react';
import { getUserStats, getUserSubscriptionFeatures } from '../components/apiClient';
import { useJWTAuth } from '../components/JWTAuthContext';
import {
  HeroWelcome,
  PerformanceOverview,
  ActivityTimeline,
  SubjectHeatmap,
  AIInsights,
  DailyChallenge,
  SocialFeatures,
  CalendarIntegration,
  NotificationsPanel,
  PredictiveScoreAnalysis
} from '../components/dashboard-v2';
import {
  QuickActions,
  PointSummaryWidget,
  AITutorInterface
} from '../components/dashboard';
import '../styles/dashboard-v2.css';

const DashboardV2: React.FC = () => {
  const { user } = useJWTAuth();
  const [userStats, setUserStats] = useState<any>({
    tests_completed: 0,
    overall_progress: 0,
    study_time_hours: 0,
    current_rank: 142
  });
  const [subscriptionData, setSubscriptionData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (user && user.id) {
        try {
          const [statsResponse, subscriptionResponse] = await Promise.all([
            getUserStats(user.id),
            getUserSubscriptionFeatures()
          ]);

          if (statsResponse && statsResponse.result) {
            setUserStats(statsResponse.result);
          }

          if (subscriptionResponse && subscriptionResponse.result) {
            setSubscriptionData(subscriptionResponse.result);
          }
        } catch (error) {
          console.error('Failed to fetch user data:', error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [user]);

  if (isLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center"
        style={{ backgroundColor: '#f8f9ff' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Loading your dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-v2 min-vh-100" style={{ backgroundColor: '#f8f9ff', paddingTop: '0px' }}>
      <div className="container py-5">
        <div className="row">
          <div className="col-12">

            {/* Hero Welcome Section */}
            <HeroWelcome userStats={userStats} />
            <div className="row g-4">
              <div className="col-lg-12 mb-4">
                <QuickActions />
              </div>
            </div>

            {/* Two Column Layout */}
            <div className="row g-4">
              {/* Left Column - Main Content */}
              <div className="col-lg-8">

                {/* Performance Overview */}
                <PerformanceOverview userStats={userStats} />

                {/* Activity Timeline */}
                <ActivityTimeline />

                {/* Subject Heatmap */}
                <SubjectHeatmap />

                {/* Daily Challenge */}
                {/* <DailyChallenge /> */}

                {/* Predictive Score Analysis */}
                {/* <PredictiveScoreAnalysis /> */}

              </div>

              {/* Right Column - Sidebar */}
              <div className="col-lg-4">

                {/* Notifications Panel */}
                <NotificationsPanel />

                {/* AI Insights */}
                <AIInsights />

                {/* Point Summary Widget */}
                <div className="mb-4">
                  <PointSummaryWidget />
                </div>

                {/* AI Tutor Interface */}
                <div className="mb-4">
                  <AITutorInterface />
                </div>

              </div>
            </div>

            {/* <div className="mt-4">
                <SocialFeatures />
            </div> */}
            
            {/* Calendar Integration */}
            {/* <div className="mt-4">
              <CalendarIntegration />
            </div> */}

    

          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardV2;
